import { render, staticRenderFns } from "./DiagnosticRecommendationDetailsModal.vue?vue&type=template&id=6161e200&scoped=true"
import script from "./DiagnosticRecommendationDetailsModal.vue?vue&type=script&lang=js"
export * from "./DiagnosticRecommendationDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticRecommendationDetailsModal.vue?vue&type=style&index=0&id=6161e200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6161e200",
  null
  
)

export default component.exports